module.exports = __webpack_public_path__ + "static/media/民眾之臨震反應.e015f34a.png";